import WrapRootElementBrowser from './src/spaces/app/WrapRootElementBrowser';

export const wrapRootElement = WrapRootElementBrowser;
